import styled from "@emotion/styled";

export const Button = styled.div`
  display: block;
  text-align: left;
  padding-top: 1rem;
`;
